import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { formatInTimeZone } from 'date-fns-tz';
import isEmpty from 'lodash.isempty';

import { Button, SelectRaw } from '../../../components';
import { getReasonsForVisit } from './api';

export default class ScheduleAppointmentForNewPatientModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool,
		onClose: PropTypes.func.isRequired,
		event: PropTypes.object,
		timeZone: PropTypes.string.isRequired,
		provider: PropTypes.object,
		onCreatePatientWithAppointment: PropTypes.func.isRequired,
		isGeneratingInviteCode: PropTypes.bool,
		inviteCode: PropTypes.string,
		userId: PropTypes.number,
	};

	state = {
		firstName: '',
		lastName: '',
		birthDate: '',
		reasonsForVisit: [],
		selectedReasonForVisit: 'none',
	};

	async getReasonsForVisit() {
		if (this.props.provider) {
			const reasonsForVisit = [{ value: 'none', label: 'Choose...' }];
			reasonsForVisit.push(
				...(await getReasonsForVisit(
					this.props.userId,
					this.props.provider.providerId
				))
			);
			this.setState({ reasonsForVisit });
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isOpen && !this.props.isOpen) {
			this.setState({
				firstName: '',
				lastName: '',
				birthDate: '',
				selectedReasonForVisit: this.state.reasonsForVisit[0].value,
			});
		} else if (!prevProps.isOpen && this.props.isOpen) {
			this.getReasonsForVisit();
		}
	}

	isInvalid = () => {
		const {
			firstName,
			lastName,
			birthDate,
			selectedReasonForVisit,
			reasonsForVisit,
		} = this.state;
		return (
			isEmpty(firstName) ||
			isEmpty(lastName) ||
			isEmpty(birthDate) ||
			selectedReasonForVisit === reasonsForVisit[0].value
		);
	};

	handleFirstNameChange = ({ target }) => {
		this.setState({ firstName: target.value });
	};

	handleLastNameChange = ({ target }) => {
		this.setState({ lastName: target.value });
	};

	handleBirthDateChange = ({ target }) => {
		this.setState({ birthDate: target.value });
	};

	handleReasonForVisitSelected = ({ target }) => {
		this.setState({ selectedReasonForVisit: target.value });
	};

	handleSubmit = () => {
		this.props.onCreatePatientWithAppointment({
			...this.state,
			appointmentId: this.props.event.id,
			visitReason: this.state.selectedReasonForVisit,
			providerCode: this.props.provider.provider_code,
		});
	};

	render() {
		const {
			provider = {},
			isOpen,
			onClose,
			timeZone,
			event = {},
			isGeneratingInviteCode,
			inviteCode,
		} = this.props;
		const {
			firstName,
			lastName,
			birthDate,
			reasonsForVisit,
			selectedReasonForVisit,
		} = this.state;

		return (
			<Modal isOpen={isOpen} onRequestClose={onClose} className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							className="close"
							onClick={onClose}
						>
							<span aria-hidden="true">×</span>
						</button>
						<h4 className="modal-title">
							New Patient Registration with Appointment
						</h4>
					</div>
					<div className="modal-body form-horizontal">
						<p>
							Fill in all fields to generate a one-time use code you can give to
							your patient to ease signing up
						</p>
						<div className="form-group">
							<label className="col-md-6 control-label">Start Date/Time</label>
							<div className="col-md-6">
								<p className="form-control-static">
									{event?.scheduled_start_dttm &&
										formatInTimeZone(
											new Date(event.scheduled_start_dttm),
											timeZone,
											'PPPPp'
										)}
								</p>
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">Duration</label>
							<div className="col-md-6">
								<p className="form-control-static">
									{event.appointment_duration} minutes
								</p>
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">Notes</label>
							<div className="col-md-6">
								<p className="form-control-static">
									{event.notes ? event.notes : '<None Entered>'}
								</p>
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">
								Patient First Name
							</label>
							<div className="col-md-6">
								{inviteCode ? (
									<p className="form-control-static">{firstName}</p>
								) : (
									<input
										type="text"
										className="form-control"
										value={firstName}
										onChange={this.handleFirstNameChange}
									/>
								)}
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">
								Patient Last Name
							</label>
							<div className="col-md-6">
								{inviteCode ? (
									<p className="form-control-static">{lastName}</p>
								) : (
									<input
										type="text"
										className="form-control"
										value={lastName}
										onChange={this.handleLastNameChange}
									/>
								)}
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">
								Patient Date of Birth
							</label>
							<div className="col-md-6">
								{inviteCode ? (
									<p className="form-control-static">{birthDate}</p>
								) : (
									<input
										type="date"
										className="form-control"
										value={birthDate}
										onChange={this.handleBirthDateChange}
									/>
								)}
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">
								Link With Provider
							</label>
							<div className="col-md-6">
								<p className="form-control-static">
									{provider.name_first} {provider.name_last},{' '}
									{provider.credentials}
								</p>
							</div>
						</div>
						<div className="form-group">
							<label className="col-md-6 control-label">Reason for Visit</label>
							<div className="col-md-6">
								{inviteCode ? (
									<p className="form-control-static">
										{
											reasonsForVisit.find(
												({ value }) => value == selectedReasonForVisit
											).label
										}
									</p>
								) : (
									<SelectRaw
										selectedValue={selectedReasonForVisit}
										options={reasonsForVisit}
										onChange={this.handleReasonForVisitSelected}
									/>
								)}
							</div>
						</div>
						{inviteCode && (
							<div className="form-group">
								<label className="col-md-6 control-label">
									Registration Code`
								</label>
								<div className="col-md-6">
									<pre>
										{`${inviteCode.substring(0, 3)}-${inviteCode.substring(
											3,
											6
										)}-${inviteCode.substring(6)}`}
									</pre>
									<span className="help-block">
										The patient will now be able to use this invite code and
										their birth date to register for a new Care Convene account.
									</span>
								</div>
							</div>
						)}
					</div>
					<div className="modal-footer">
						{inviteCode ? (
							<Button title="Close" onClick={onClose} />
						) : (
							<React.Fragment>
								<Button title="Cancel" onClick={onClose} />
								<Button
									primary
									title="Schedule Appointment"
									disabled={this.isInvalid() || isGeneratingInviteCode}
									onClick={this.handleSubmit}
								/>
							</React.Fragment>
						)}
					</div>
				</div>
			</Modal>
		);
	}
}
